export const GET_ALLPRODUCT_DATA_SUCCESS="GET_ALLPRODUCT_DATA_SUCCESS"
export const GET_EXCLUSIVE_DEAL_DATA_SUCCESS="GET_EXCLUSIVE_DEAL_DATA_SUCCESS"
export const GET_CHICKEN_BUCKETS_DATA_SUCCESS="GET_CHICKEN_BUCKETS_DATA_SUCCESS"
export const GET_NEW_LAUNCH_DATA_SUCCESS="GET_NEW_LAUNCH_DATA_SUCCESS"
export const GET_BIRYANI_BUCKETS_DATA_SUCCESS="GET_BIRYANI_BUCKETS_DATA_SUCCESS"
export const GET_BOX_MEALS_DATA_SUCCESS="GET_BOX_MEALS_DATA_SUCCESS"
export const GET_BURGERS_DATA_SUCCESS="GET_BURGERS_DATA_SUCCESS"
export const GET_STAY_HOME_SPECIALS_DATA_SUCCESS="GET_STAY_HOME_SPECIALS_DATA_SUCCESS"
export const GET_SNACKS_DATA_SUCCESS="GET_SNACKS_DATA_SUCCESS"
export const GET_BEVERAGES_DATA_SUCCESS="GET_BEVERAGES_DATA_SUCCESS"


